import React from 'react';
import { AboutCard, Button } from 'components';
import Section from '../components/Section';
import './About.scss';

const About = ({
  data: {
    sectionTitle: { subTitle, title, body, button },
    numbers,
    cardsHeading,
    cards,
  },
}) => (
  <Section className="about">
    <div className="about__top-container">
      <div className="about__content-container">
        <label data-sal="slide-up" data-sal-easing="ease" className="label">
          {subTitle}
        </label>
        <h2 data-sal="slide-up" data-sal-easing="ease">
          {title}
        </h2>
        <p className="about__info-text body-2" data-sal="slide-up" data-sal-easing="ease">
          {body}
        </p>
        <Button
          className="about__button"
          variant="secondary"
          data-sal="slide-up"
          data-sal-easing="ease"
          to={button.url}
        >
          {button.text}
        </Button>
      </div>
      <div className="about__number-containers-wrapper">
        {numbers.map((number) => (
          <div
            className="about__number-container"
            key={number.text}
            data-sal="slide-left"
            data-sal-easing="ease"
          >
            <h1 className="about__number">{number.number}</h1>
            <p className="body-2">{number.text}</p>
          </div>
        ))}
      </div>
      <Button className="about__button-mobile" variant="secondary" to={button.url}>
        {button.text}
      </Button>
    </div>
    <p className="about__cards-title body-2" data-sal="slide-up" data-sal-easing="ease">
      {cardsHeading}
    </p>
    <div className="about__cards-container">
      {cards.map((card, index) => (
        <AboutCard
          image={card.imageContainer.image.publicURL}
          altText={card.imageContainer.altText}
          title={card.title}
          description={card.description}
          key={card.title}
          index={index}
        />
      ))}
    </div>
  </Section>
);
export default About;
